import { useContext } from 'react'

import { Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import AcademicFocuses from '../Audience/AcademicFocuses'
import CreditAmount from './CreditAmount'
import Credits from './Credits'

const Academics = () => {
  const { exceed5Tags } = useContext(ContentModalContext)

  return (
    <Section title="Academics">
      <Credits />
      <CreditAmount />
      {exceed5Tags && <Alert severity="error">Please select no more than 5 topics.</Alert>}
      <Box>
        <AcademicFocuses focusOnly />
      </Box>
    </Section>
  )
}

export default Academics
